import { createAction, props } from '@ngrx/store';
import { UserView } from '@iota/inh-core-v1-management-client';

export enum UserActionTypes {
    LoadUser = '[User] Load User',
    LoadUserSuccess = '[User] Load User Success',
    LoadUserFailure = '[User] Load User Failure',

    Logout = '[User] Logout User',
    LogoutSuccess = '[User] Logout User Success',
    LogoutFailure = '[User] Logout User Failure'
}

export const LoadUser = createAction(UserActionTypes.LoadUser);
export const LoadUserSuccess = createAction(UserActionTypes.LoadUserSuccess, props<{ user: UserView }>());
export const LoadUserFailure = createAction(UserActionTypes.LoadUserFailure, props<{ error: any }>());

export const Logout = createAction(UserActionTypes.Logout);
export const LogoutSuccess = createAction(UserActionTypes.LogoutSuccess);
export const LogoutFailure = createAction(UserActionTypes.LogoutFailure, props<{ error: any }>());
